import React, { forwardRef } from 'react';
import { RadioGroup, Text } from 'rsuite';
import AnnotatedRadio from './AnnotatedRadio';
import { isNullUndefinedOrEmptyString } from '../../common/utils';

export interface RadioGroupWithErrorStatusProps {
  onChange: (value: any) => void;
  options: any[];
  defaultOption: any;
  disabled?: boolean;
  legend?: string | React.ReactNode;
  ariaInvalid?: boolean;
  ariaDescribedby?: string;
}

export const RadioGroupWithErrorStatus = React.memo(
  forwardRef<HTMLDivElement, RadioGroupWithErrorStatusProps>(
    (
      {
        onChange,
        options,
        defaultOption,
        disabled,
        legend,
        ariaInvalid,
        ariaDescribedby,
      },
      ref
    ) => {
      const radioGroup = (
        <RadioGroup
          ref={ref}
          onChange={onChange}
          value={defaultOption?.key}
          aria-invalid={ariaInvalid ? true : undefined}
          aria-describedby={ariaDescribedby}
        >
          {options?.map((opt, idx) => {
            const hasAnnotationText = !isNullUndefinedOrEmptyString(
              opt.description
            );
            const optionKey = opt.key;
            return (
              <AnnotatedRadio
                key={`radio_option_${optionKey}_${idx}`}
                value={optionKey}
                label={`${opt.label}`}
                annotation={() =>
                  hasAnnotationText ? <Text>{opt.description}</Text> : null
                }
                disabled={disabled}
              />
            );
          })}
        </RadioGroup>
      );

      if (legend) {
        return (
          <fieldset style={{ border: 'none', margin: 0, padding: 0 }}>
            <legend className="sr-only">{legend}</legend>
            {radioGroup}
          </fieldset>
        );
      }

      return radioGroup;
    }
  )
);
